import { render, staticRenderFns } from "./MspListaFeedback.vue?vue&type=template&id=4997aaa3"
import script from "./MspListaFeedback.vue?vue&type=script&lang=js"
export * from "./MspListaFeedback.vue?vue&type=script&lang=js"
import style0 from "./MspListaFeedback.vue?vue&type=style&index=0&id=4997aaa3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports